import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Textarea, Textfield } from "../../../../components/core";
import { InputNumber } from "primereact/inputnumber";

export default function CellEditingTable({
	data = [
		{
			userType: "Regular",
			description: "Sample Description for regular",
			monthlyFee: 1.1,
		},
		{
			userType: "Premium",
			description: "Sample Description for Premium",
			monthlyFee: 1.2,
		},
		{
			userType: "VIP",
			description: "Sample Description for vip",
			monthlyFee: 1.3,
		},
	],
	headers = [
		{ field: "userType", header: "Locker User Type", type: "textfield" },
		{ field: "description", header: "Description", type: "textarea" },
		{ field: "monthlyFee", header: "Monthly Fee", type: "numberfield" },
	],
	handleOnCellEditComplete,
	loading,
	primaryKey,
}) {
	const [localData, setLocalData] = useState([]);
	const [editedRows, setEditedRows] = useState(new Set());
	React.useEffect(() => {
		setLocalData([]);
		setLocalData(JSON.parse(JSON.stringify(data)));
	}, [data]);
	const onCellEditComplete = (e) => {
		// get the event object
		let { rowData, newValue, field, originalEvent: event } = e;
		// Localy assigned the table
		rowData[field] = newValue;
		setEditedRows((prevEditedRows) =>
			new Set(prevEditedRows).add(rowData["userTypeId"])
		);
		handleOnCellEditComplete(
			data.findIndex((x) => x[primaryKey] === rowData[primaryKey]),
			newValue,
			field,
			rowData
		);
	};

	const cellEditor = (options, type) => {
		console.log(options);
		switch (type) {
			case "textarea":
				return textareaEditor(options);
			case "numberfield":
				return numberEditor(options);
			default:
				return textEditor(options);
		}
	};

	const textEditor = (options) => {
		return (
			<Textfield
				value={options.value}
				onChange={(e) => options.editorCallback(e.target.value)}
			/>
		);
	};
	const textareaEditor = (options) => {
		return (
			<Textarea
				value={options.value}
				onChange={(e) => options.editorCallback(e.target.value)}
			/>
		);
	};
	const numberEditor = (options) => {
		console.log(options.value);
		return (
			//   <NumberFormatBase
			//     customInput={Textfield}
			//     value={options.value}
			//     onChange={(e) => options.editorCallback(e.target.value)}
			//   />
			// <Textfield
			// 	key={"int"}
			// 	type={"int"}
			// 	className={
			// 		"my-auto w-full h-10 border-2 focus:outline-yellow-400 rounded-md p-1"
			// 	}
			// 	placeholder={"Monthly Fee"}
			// 	onChange={(e) => options.editorCallback(e.target.value)}
			// 	name="monthlyFee"
			// 	value={options.value}
			// />
			<InputNumber
				prefix="₱"
				minFractionDigits={2}
				maxLength={10}
				className={
					"my-auto w-full h-10 border-2 focus:outline-yellow-400 rounded-md p-1"
				}
				value={options.value}
				onValueChange={(e) => options.editorCallback(e.value)}
			/>
		);
	};
	const philippineMoneyTemplate = (rowData, field) => {
		if (rowData[field] !== null) {
			return <p>₱{rowData[field]}</p>;
		}
		return <p>{rowData[field]}</p>;
	};

	return (
		<div className="card p-fluid">
			<DataTable
				paginatorTemplate="CurrentPageReport RowsPerPageDropdown FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
				currentPageReportTemplate="Rows per page"
				paginator
				rowsPerPageOptions={[10, 20, 50]}
				rows={10}
				showGridlines={true}
				stripedRows={true}
				sortMode="multiple"
				removableSort
				cellSelection
				selectionMode="single"
				value={localData}
				oncell
				rowClassName={(rowData) =>
					editedRows.has(rowData["userTypeId"])
						? "bg-primary-primaryYellowLight border border-secondary-lightestGray"
						: ""
				}
				tableStyle={{
					minWidth: "50rem",
					//   wordWrap: "break-word",
					//   tableLayout: "fixed",
				}}
			>
				{headers.map(({ field, header, type }) => {
					if (type === "numberfield") {
						return (
							<Column
								key={field}
								field={field}
								header={header}
								style={{ width: "25%" }}
								headerStyle={{
									backgroundColor: "#FECD08",
									color: "black",
								}}
								sortable
								body={(rowData) => philippineMoneyTemplate(rowData, field)}
								editor={(options) => cellEditor(options, type)}
								onCellEditComplete={onCellEditComplete}
							/>
						);
					}
					return (
						<Column
							key={field}
							field={field}
							header={header}
							style={{ width: "50%" }}
							sortable
							headerStyle={{
								backgroundColor: "#FECD08",
								color: "black",
							}}
							editor={(options) => cellEditor(options, type)}
							onCellEditComplete={onCellEditComplete}
						/>
					);
				})}
			</DataTable>
		</div>
	);
}
